import { render, staticRenderFns } from "./studelay.vue?vue&type=template&id=0a6a4a0a&scoped=true"
import script from "./studelay.vue?vue&type=script&lang=js"
export * from "./studelay.vue?vue&type=script&lang=js"
import style0 from "./studelay.vue?vue&type=style&index=0&id=0a6a4a0a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a4a0a",
  null
  
)

export default component.exports